export const MailThreadArchiveDetails = ['ArchivedBy', 'ArchivedOn'];
export const LastMessage = ['MessageBody', 'SentOn'];
export const CHAT_ENTITY_FIELDS = {
    EntityBasedChatGQL: [
        'MailThreadId',
        'Tags',
        'TopicId',
        'TopicName',
        'TopicEntityName',
        'Recipients',
        'IsMailThreadArchived',
        { MailThreadArchiveDetails: MailThreadArchiveDetails },
        { MailThreadLastMessage: LastMessage }
    ],
    EntityBasedChat: [
        'MailThreadId',
        'Tags',
        'TopicId',
        'TopicName',
        'TopicEntityName',
        'Recipients',
        'IsMailThreadArchived',
        'MailThreadArchiveDetails'
    ],
    Connection: [
        'ItemId',
        'ParentEntityName',
        'ParentEntityID',
        'ChildEntityName',
        'ChildEntityID'
    ],

    EntityBasedChatCustomer: [
        'MailThreadId',
        'TopicName',
        'TopicEntityName',
        'Recipients'
    ],
    EntityBasedChatAdvisor: [
        'MailThreadId',
        'Tags',
        'TopicId',
        'TopicName',
        'TopicEntityName',
        'Recipients'
    ]
};
export const MailThreadPayload = { Active: true, Read: null, IncludeLastMessage: true};
export const ChatEntityFields = CHAT_ENTITY_FIELDS;
export const CHAT_PANEL = 'chatPanel';

export const OrderBy = {
    ascending: "'MailThreadLastMessage.SentOn':-1",
    descending: "'MailThreadLastMessage.SentOn':1"
};

export const EntityBasedChatPagination = {
    pageNumber: 0,
    pageSize: 100
};

export enum CommandTypes {
    Create = 'Create',
    Update = 'Update',
    Delete = 'Delete',
    Read = 'Read',
    Aggregate = 'AggregateQuery'
}

export const ChatEntity = {
    EntityBasedChat: 'EntityBasedChat',
    Connection: 'Connection'
};

export const ENTITY_BASED_CHAT_TABLE_TAGS = {
    IsAEntityBasedChat: 'Is-A-EntityBasedChat',
    ChatOfEntityBasedChat: 'Chat-Of-EntityBasedChat'
};

export enum TabName {
    ThreadView = 'ThreadView',
    ThreadMessageView = 'ThreadMessageView',
    EmptyView = 'EmptyView',
    NotificationView = 'NotificationView',
    PersonChatView = 'PersonChatView',
    TopicChatView = 'TopicChatView'
}

export enum MailStaticData {
    mailSubjectKey = 'NEW_MESSAGE'
}
export enum EntityBasedChatFilters {
    Tags = 'Tags',
    Recipients = 'Recipients',
    MailThreadId = 'MailThreadId',
    IsMailThreadArchived = 'IsMailThreadArchived',
    TopicEntityName = 'TopicEntityName',
    TopicName = 'TopicName'
}

export const ConnectionsTableFilters = {
    ChildEntityID: 'ChildEntityID',
    ChildEntityName: 'ChildEntityName',
    ParentEntityID: 'ParentEntityID',
    ParentEntityName: 'ParentEntityName',
    Person: 'Person',
    User: 'User',
    PageNumber: 0,
    PageSize: 100
};

export const OnlyMessageQueryPayload = {
    ResponseKeys: ['MessagingThreadNotification'],
    ResponseKeyFilterOperator: 'In',
    OnlyUnread: true,
    OrderByCreatedDate: 1,
    ReturnCount: true,
    PageNumber: 1,
    PageSize: 100
};

export const MessageNotificationKeys = [
    'MessagingThreadNotification',
    'ThreadRecipientsUpdated'
];
